export default __webpack_public_path__ + "static/media/info.770b1fc7.svg";